import { action } from 'satcheljs';

export interface REMOVE_MESSAGE_AD_LISTActionMessage {
    remainingShowAdCount: number;
}
const defaultExport: (remainingShowAdCount: number) => REMOVE_MESSAGE_AD_LISTActionMessage = action(
    'REMOVE_MESSAGE_AD_LIST',
    (remainingShowAdCount: number): REMOVE_MESSAGE_AD_LISTActionMessage => {
        return {
            remainingShowAdCount,
        };
    }
);
export default defaultExport;
